module.exports = __webpack_public_path__ + "img/26.68b88df7.png";